import React, {useState} from 'react';

import {MonitorServiceContentDisplayerModal} from 'components/ais/monitor-services-card/monitor-service-content-displayer-modal/monitor-service-content-displayer-modal';
import {EMonitorServiceContentDisplayerType} from 'components/table/columns/monitor-services-content-displayer/monitor-services-content-displayer.types';
import {IColumnFormatterProps} from 'components/table/table-types';

import 'components/table/columns/monitor-services-content-displayer/monitor-services-content-displayer.less';

type TMonitorServicesContentDisplayerProps = {
    type: EMonitorServiceContentDisplayerType;
} & Pick<IColumnFormatterProps, 'record'>;

export const MonitorServicesContentDisplayer = ({
    type, record,
}: TMonitorServicesContentDisplayerProps) => {
    const [isVisible, setVisible] = useState(false);

    const handleClose = () => setVisible(false);

    const title = type === EMonitorServiceContentDisplayerType.request
        ? 'Содержание запроса'
        : 'Содержание ответа';

    return (
        <>
            <MonitorServiceContentDisplayerModal
                visible={isVisible}
                onClose={handleClose}
                type={type}
                entityId={record?.id ? String(record.id) : undefined}
                modalTitle={title}
            />
            <div
                className="monitor-services-request-content"
                onClick={() => setVisible(true)}
            >
                {title}
            </div>
        </>
    );
};
